<template>
    <v-row class="ma-0 pa-0" justify="start">
        <v-col class="ma-0 pa-0" cols="auto">
            <span class="chart_title">{{ statistic_title_name == null ? statistic_name : statistic_title_name }}</span>
        </v-col>
        <v-col cols="12" :style="{height: chart_height + 'px'}" class="py-1">
            <v-chart
                class="chart_style"
                :option="graph_options"
                autoresize
                :ref="chart_ref"
                :id="chart_id"
            ></v-chart>
        </v-col>
    </v-row>
</template>

<script>
import VChart, { THEME_KEY } from 'vue-echarts';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers'; 'echarts/charts';
import {
    TitleComponent,
    TooltipComponent,
    LegendComponent,
} from 'echarts/components';
import { normalizeForecastingChannelName } from "../forecastingChannelColors";

use([
    CanvasRenderer,
    TitleComponent,
    TooltipComponent,
    LegendComponent,
]);
export default {
    name: 'PredictionPieChart',
    props: [
        'statistic_title_name',
        'value',
        'chart_ref',
        'chart_id',
        'link',
        'colors',
        'channelColors'
    ],
    provide: {
        [THEME_KEY]: 'light',
    },
    components: {
        VChart
    },
    data: () => ({
        data: [],
        chart_height: screen.width * 0.15,
    }),
    watch: {
        value: function(){
            if(this.value != null){
                this.data = this.value;
            }
        }
    },
    mounted(){
        if(this.value != null){
            this.data = this.value;
        }
    },
    methods: {
        open_further_details: function(){
            if(this.link){
                this.$router.replace(this.link);
            }
        },
        getChannelColor: function(channel, index) {
            const normalizedChannel = normalizeForecastingChannelName(channel);

            if (
                this.channelColors &&
                Object.prototype.hasOwnProperty.call(this.channelColors, channel)
            ) {
                return this.channelColors[channel];
            }

            if (
                this.channelColors &&
                Object.prototype.hasOwnProperty.call(this.channelColors, normalizedChannel)
            ) {
                return this.channelColors[normalizedChannel];
            }

            return this.resolvedColors[index % this.resolvedColors.length];
        },
    },
    computed: {
        graph_options: function() {
            let dataset = this.data
            let chart_data = [];
            let data_titles = [];
            if(dataset != null){
                for(let idx = 1; idx < dataset.length; idx ++){
                    chart_data.push({
                        name: dataset[idx][0],
                        value: dataset[idx][1],
                        tooltip: dataset[idx][2],
                        itemStyle: {
                            color: this.getChannelColor(dataset[idx][0], idx - 1),
                        },
                    })
                    data_titles.push(dataset[idx][0]);
                }
            }

            const option = {
                title: {
                    text: '',
                    left: 'center',
                },
                color: this.resolvedColors,
                tooltip: {
                    trigger: 'item',
                    formatter: function (param) {
                        return param.data['tooltip'];
                    }
                },
                legend: {
                    show: false,
                    orient: 'vertical',
                    left: '75%',
                    data: data_titles,
                },
                series: [
                    {
                        name: '',
                        type: 'pie',
                        radius: [ '50%','98%'],
                        center: ['50%', '50%'],
                        // color: COLOR_PALETTE,
                        data: chart_data,
                        label: {
                            show: true,
                            fontSize: 12,
                            color: '#000000',
                            formatter: '{d}%',
                            position: 'inside',
                        },
                        labelLine: {
                            show: false
                        },
                    },
                ],
            }
            return option;
        },
        resolvedColors: function() {
            return this.colors && this.colors.length > 0 ? this.colors : [
                '#FF4C4C',
                '#4C9BFF',
                '#4CD7D0',
                '#F4B400',
                '#A07BFF',
                '#00C49F',
                '#FFBB28',
                '#FF7F50',
                '#1E90FF',
                '#20B2AA',
                '#FFD700',
                '#BA68C8',
                '#2E8B57',
                '#FFA500',
                '#E57373',
                '#64B5F6',
                '#81C784',
                '#FF8A65',
                '#9575CD',
                '#4DB6AC',
                '#F06292',
                '#7986CB',
                '#AED581',
                '#FFD54F',
                '#90A4AE'
            ];
        },
    },
}
</script>

<style scoped>
    .chart_title{
        font-family: "Poppins" !important;
        font-weight: 600;
        font-size: 12pt !important;
        line-height: 40px;

        display: block;
        max-width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .chart_wrapper{
        height: 28vh;
        font-family: "Gothic" !important;
    }
    .chart_style {
        height: 100%;
        width: 100%;
    }
</style>
